const { Component } = Shopware;

Component.register('topdata-es-synonym-suggestion-form', {
    template: `
        <sw-modal
            :title="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.title')"
            @modal-close="$emit('close')"
        >
                <sw-container columns="1fr" gap="20px">
                    <sw-text-field
                        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.termLabel')"
                        :value="suggestion.term"
                        disabled
                    />

                    <sw-text-field
                        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.targetTermLabel')"
                        :value="suggestion.targetTerm"
                        disabled
                    />

                    <sw-single-select
                        v-model:value="editedLanguage"
                        :options="languageOptions"
                        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.languageLabel')"
                        :show-clearable="true"
                    />

                    <sw-text-field
                        v-model:value="editedSynonyms"
                        :label="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.synonymsLabel')"
                        :helpText="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.synonymsHelp')"
                        placeholder="term1, term2, ..."
                    />
                </sw-container>

                <template #modal-footer>
                    <sw-button
                        variant="default"
                        @click="$emit('close')"
                    >
                        {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.cancelButton') }}
                    </sw-button>

                    <sw-button
                        variant="primary"
                        @click="onConfirm"
                    >
                        {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.confirmButton') }}
                    </sw-button>
                </template>
        </sw-modal>
    `,

    props: {
        suggestion: {
            type: Object,
            required: true,
        },
    },

    emits: ['confirm', 'close'],

    data() {
        return {
            editedSynonyms: this.suggestion.suggestedSynonyms || '',
            editedLanguage: this.suggestion.languageId || null,
        };
    },

    computed: {
        languageOptions() {
            return [{
                value: null,
                label: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.form.languageGlobal'),
            }, {
                value: 'de',
                label: 'Deutsch',
            }, {
                value: 'en',
                label: 'English',
            }, {
                value: 'fr',
                label: 'Français',
            }];
        },
    },

    watch: {
        suggestion(newVal) {
            this.editedSynonyms = newVal.suggestedSynonyms || '';
            this.editedLanguage = newVal.languageId || null;
        },
    },

    methods: {
        onConfirm() {
            this.$emit('confirm', this.editedSynonyms, this.editedLanguage);
        },
    },
});